import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { Optional } from 'utility-types';
import type { AutoFeedbackItemTransformed } from '@scale/shared/types/chat';

export type AutoFeedbackState = {
  feedback?: AutoFeedbackItemTransformed[];
};

type AutoFeedbackStore = {
  autoFeedbackState: Record<string, AutoFeedbackState>;
  setAutoFeedbackState: (storeKey: string, newState: Optional<AutoFeedbackState>) => void;
  getAutoFeedbackState: (storeKey: string) => AutoFeedbackState | null;
};

/**
 * Store for persisting AutoFeedback Store
 */
export const useAutoFeedbackStore = create<AutoFeedbackStore>()(
  devtools((set, get) => ({
    autoFeedbackState: {},
    setAutoFeedbackState: (storeKey: string, newState: Optional<AutoFeedbackState>) => {
      set(state => ({
        autoFeedbackState: {
          ...state.autoFeedbackState,
          [storeKey]: newState,
        },
      }));
    },
    getAutoFeedbackState: (storeKey: string) => {
      const cachedState = get().autoFeedbackState[storeKey];
      if (!cachedState) {
        return null;
      }

      return cachedState;
    },
  })),
);
